import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "load",
  class: "loader"
}
const _hoisted_2 = { key: 0 }

import { ref, computed, withDefaults, watch } from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import vSelect from 'vue-select'
import { useIntersectionObserver } from '@vueuse/core'
import environment from '@/configs/environtment'

// Define props with types

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectAsync',
  props: {
    endpoint: { default: '' },
    fieldValue: { default: 'Id' },
    fieldLabel: { type: Function, default: () => 'Name' },
    searchFields: { default: () => [] },
    modelValue: { default: null },
    searchCustom: { default: () => [] },
    id: { default: '' },
    classname: { default: '' },
    selectable: { type: Function, default: () => true },
    inputId: { default: '' },
    placeholder: { default: 'Pilih' }
  },
  emits: ["update:modelValue", "change", "search:focus"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', val: any): void
  (e: 'change', val: any): void
  (e: 'search:focus'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { endpoint: string, fieldValue: string, fieldLabel: (item: any) => string, searchFields: Array<string>, modelValue: any, searchCustom: Array<any>, id: string, classname: string, selectable: (item: any) => boolean, inputId: string, placeholder: string }



const isProduction = computed(() => environment.getMode() === 'production')

// Define emits


const isLoading = ref(false)
const options = ref<{ label: string; value: any }[]>([])
const inputSearch = ref('')
const hasNextPage = ref(false)
const pagination = ref<{ count: number; pageNumber: number; pageSize: number; limit: number }>({
  count: 0,
  pageNumber: 1,
  pageSize: 10,
  limit: 0
})

const valueSelect = computed({
  get: () => props.modelValue,
  set: (v: any) => emit('update:modelValue', v)
})

const selectableRow = (row: any): boolean => props.selectable?.(row) ?? true

// Debounce function using vanilla JavaScript
const debounce = <F extends (...args: any[]) => Promise<void>>(func: F, delay: number): ((...args: Parameters<F>) => void) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null
  return (...args: Parameters<F>) => {
    if (timeoutId) clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      func(...args)
    }, delay)
  }
}

const getData = async (): Promise<void> => {
  try {
    const { result, error, count, pagenumber } = await apiUseCase.get(`${props.endpoint}${returnUrlPrams({
      search: inputSearch.value,
      filterField: props.searchFields,
      custom: props.searchCustom,
      pageNumber: pagination.value.pageNumber
    })}`)

    if (error) {
      const errorMessage = typeof error === 'string' ? error : 'An unknown error occurred'
      throw new Error(errorMessage)
    }

    if (pagenumber === 1) options.value = []
    pagination.value.limit = count
    pagination.value.count += result.length
    hasNextPage.value = pagination.value.count < pagination.value.limit

    options.value.push(...result.data.map((item: any) => ({
      ...item,
      label: typeof props.fieldLabel === 'function' ? props.fieldLabel(item) : item[props.fieldLabel ?? ''],
      value: item[props.fieldValue ?? '']
    })))
  } catch (err) {
    console.error(err)
  } finally {
    isLoading.value = false
  }
}

// Create a debounced version of getData
const debouncedGetData = debounce(getData, 500) //  second delay

// Watching the inputSearch for changes
watch(inputSearch, (newVal) => {
  isLoading.value = true
  debouncedGetData()
  // if (newVal.length >= 3) {
  // } else {
  //   options.value = [] // Clear options if input length is less than 3
  // }
})

const onOpen = (): void => {
  if (pagination.value.count === 0) getData()
  emit('search:focus')
}

const onSearch = (val: string): void => {
  if (val !== inputSearch.value) {
    pagination.value.pageNumber = 1
    options.value = []
    hasNextPage.value = false
    inputSearch.value = val
  }
}

const { stop } = useIntersectionObserver(
  ref<HTMLElement | null>(null),
  ([{ isIntersecting }]) => {
    if (isIntersecting) getData()
  }
)

const optionSelected = (select: any): void => {
  emit('change', select || null)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(vSelect), {
      modelValue: _unref(valueSelect),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(valueSelect) ? (valueSelect).value = $event : null)),
      class: _normalizeClass(`${_unref(isProduction) ? 'select-primary' : 'select-secondary'} ${__props.classname}`),
      inputId: props.inputId,
      placeholder: props.placeholder,
      clearable: props.clearable,
      id: props.id,
      disabled: props.disabled,
      options: options.value,
      onOpen: onOpen,
      onSearch: onSearch,
      selectable: selectableRow,
      "onOption:selected": optionSelected,
      "onOption:deselecting": optionSelected,
      loading: isLoading.value,
      autofocus: false
    }, {
      "list-footer": _withCtx(() => [
        (hasNextPage.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_1, " Sedang memuat... ", 512))
          : _createCommentVNode("", true)
      ]),
      "no-options": _withCtx(({ searching, loading }) => [
        (searching || loading)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Tidak ada data ditemukan. "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "class", "inputId", "placeholder", "clearable", "id", "disabled", "options", "loading"])
  ]))
}
}

})